import { Tooltip } from "antd";
import { FolderOpenFilled } from "@ant-design/icons";
import dayjs from 'dayjs'

const Columns = (handleOpenChangeLog, gapsTableFilter) => {
  return [
     {
      title: 'Activo',
      dataIndex: ['dependency_control', 'dependency', 'asset', 'name'],
      key: 'asset',
      sorter: (a, b) => a.dependency_control?.dependency?.asset?.name.localeCompare(b.dependency_control?.dependency?.asset?.name),
      defaultFilteredValue: gapsTableFilter.dashboardAssetsFilter,
      filterSearch: true,
      filters: gapsTableFilter.assets.map(asset => ({
        text: asset.name,
        value: asset.name
      })),
      onFilter: (value, record) => record.dependency_control?.dependency?.asset?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '20%'
    },
    {
      title: 'Dependencia',
      dataIndex: ['dependency_control', 'dependency', 'name'],
      key: 'dependency',
      sorter: (a, b) => a.dependency_control?.dependency?.name.localeCompare(b.dependency_control?.dependency?.name),
      filterSearch: true,
      filters: gapsTableFilter.dependencies.map(dep => ({
        text: dep.name,
        value: dep.name
      })),
      onFilter: (value, record) => record.dependency_control?.dependency?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '16%'
    },
    {
      title: 'Control',
      dataIndex: ['dependency_control', 'control', 'title'],
      key: 'control',
      sorter: (a, b) => a.dependency_control?.control?.title.localeCompare(b.dependency_control?.control?.title),
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      ellipsis: true,
      render: (_, record) => {
        const title = record.dependency_control?.control?.title;

        if (!title) return <span style={{ color: '#999' }}>Sin título</span>;

        const truncated = title.length > 50 ? `${title.substring(0, 50)}...` : title;

        return title.length > 40 ? (
          <Tooltip title={title}>
            <span>{truncated}</span>
          </Tooltip>
        ) : (
          <span>{truncated}</span>
        );
      },
      width: '18%'
    },
    {
      title: 'Prioridad',
      dataIndex: ['dependency_control', 'control', 'priority'],
      align: 'center',
      key: 'priority',
      sorter: (a, b) =>
        (a.dependency_control?.control?.priority?.name || '').localeCompare(
          b.dependency_control?.control?.priority?.name || ''
        ),
      filters: gapsTableFilter.priorities.map(priority => ({
        text: priority.name,
        value: priority.name
      })),
      onFilter: (value, record) => record.dependency_control?.control?.priority?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      render: (_, record) => {
        const priorityName = record.dependency_control?.control?.priority?.name;

        if (!priorityName) {
          return <span style={{ color: '#999' }}>-</span>;
        }

        return <span>{priorityName}</span>;
      },
      width: '12%'
    },
    {
      title: 'Tipo de GAP',
      dataIndex: 'type',
      key: 'type',
      sorter: (a, b) => a.type.localeCompare(b.type),
      filters: gapsTableFilter.types.map(type => ({
        text: type.name,
        value: type.name
      })),
      defaultFilteredValue: gapsTableFilter.filteredTypeValue,
      onFilter: (value, record) => {
        // Si es filtro combinado desde dashboard
        if (gapsTableFilter.isCombinedFilter) {
          return record.status === gapsTableFilter.dashboardStatusFilter && 
                record.type === gapsTableFilter.dashboardTypeFilter;
        }
        // Filtro normal
        return record.type === value;
      },
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '14%'
    },
    {
      title: 'Estado del GAP',
      dataIndex: 'status',
      key: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '10%'
    },
    {
      title: 'Issue en Curso',
      dataIndex: 'issue_in_progress',
      align: 'center',
      key: 'issue_in_progress',
      sorter: (a, b) => {
        const nameA = a.issue_in_progress || '';
        const nameB = b.issue_in_progress || '';
        return nameA.localeCompare(nameB);
      },
      filters: gapsTableFilter.statuses.map(status => ({
        text: status.name,
        value: status.name
      })),
      defaultFilteredValue: gapsTableFilter.filteredStatusValue,
      onFilter: (value, record) => {
        // Si es filtro combinado desde dashboard
        if (gapsTableFilter.isCombinedFilter) {
          return record.status === gapsTableFilter.dashboardStatusFilter && 
                record.type === gapsTableFilter.dashboardTypeFilter;
        }
        // Filtro normal
        return record.status === value;
      },
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      render: (issue_in_progress) => issue_in_progress || '-',
      width: '14%'
    },
    {
      title: 'Issue Finalizados',
      dataIndex: 'issues_finished',
      align: 'center',
      key: 'issues_finished',
      sorter: (a, b) => {
        const nameA = (a.issues_finished || []).join(', ');
        const nameB = (b.issues_finished || []).join(', ');
        return nameA.localeCompare(nameB);
      },
      filters: gapsTableFilter.issuesInProgress.map(issue => ({
        text: issue.name,
        value: issue.name
      })),
      onFilter: (value, record) => record.issue_in_progress === value,
      onHeaderCell: () => ({  style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' }, className: 'custom-filter-icon' }),
      showSorterTooltip: false,
      render: (issues_finished) => 
      issues_finished?.length 
        ? issues_finished.join(', ') 
        : '-',
      width: '13%'
    },
    {
      title: "Fecha Comprometida",
      dataIndex: "date_committed",
      key: "date_committed",
      sorter: (a, b) => {
        const dateA = a.date_committed ? new Date(a.date_committed).getTime() : 0;
        const dateB = b.date_committed ? new Date(b.date_committed).getTime() : 0;
        return dateA - dateB;
      },
      filters: gapsTableFilter.issuesFinished.map(issue => ({
        text: issue.name,
        value: issue.name
      })),
      onFilter: (value, record) => (record.issues_finished || []).includes(value),
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '15%',
      render: (date_committed) =>
        date_committed
          ? dayjs(date_committed).format('DD/MM/YYYY')
          : 'No especificada'
    },
    {
      title: 'Responsable',
      dataIndex: 'area',
      align: 'center',
      key: 'area',
      sorter: (a, b) => {
        const nameA = a.area?.name || '';
        const nameB = b.area?.name || '';
        return nameA.localeCompare(nameB);
      },
      defaultFilteredValue: gapsTableFilter.dashboardAreasFilter,
      filters: gapsTableFilter.areas.map(area => ({
        text: area.name,
        value: area.name
      })),
      onFilter: (value, record) => record.area?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      render: (area) => area?.name || 'N/A',
      width: '15%'
    }, 
    {
      title: "Log",
      dataIndex: "log",
      key: "log",
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } 
      }),
      width: '6%',
      render: (_, record) => (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Ver Log">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#B22222' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
        </div>
      )
    }
  ];
};

export default Columns;